import { FC } from "react";
import { RadioInput } from "../form-fields";
import { IOption } from "../form-fields/RadioInput";
import FormGroup from "../forms/FormGroup";
import { useTranslation } from "react-i18next";

interface CustomRadioInputProps {
  value: "yes" | "no" | null;
  onValueChange: (value: "yes" | "no" | null) => void;
  formLabel: string;
  error?: string | boolean | null;
}

const CustomRadioInput: FC<CustomRadioInputProps> = ({ error, formLabel, onValueChange, value }) => {
  const { t } = useTranslation("components", { keyPrefix: "forms.radioInput" });
  const yesNoOptions: IOption<"yes" | "no">[] = [
    { value: "yes", label: t("yes") },
    { value: "no", label: t("no") },
  ];

  return (
    <FormGroup title="" fullWidth>
      <RadioInput error={error} name={formLabel} onValueChange={onValueChange} value={value} options={yesNoOptions} aria-label={formLabel} />
    </FormGroup>
  );
};

export default CustomRadioInput;
